module.exports = __webpack_public_path__ + "static/media/dinesafe-app-edit-meal.270dc722.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/dinesafe-app-edit-meal.png
// module id = 115
// module chunks = 0